import { render, staticRenderFns } from "./igt-discrete-upgrade.vue?vue&type=template&id=55a454b4&scoped=true&"
import script from "./igt-discrete-upgrade.vue?vue&type=script&lang=js&"
export * from "./igt-discrete-upgrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a454b4",
  null
  
)

export default component.exports